import api from './api';
const BASE = '/transactiontikane';

const service = {
  list: (tiKaneId, params = {}) =>
    api.get(`${BASE}/${tiKaneId}`, {
      params: { functionCode: 'TRANS_VIEW', ...params },
    }).then((r) => r.data),

  create: (tiKaneId, data) =>
    api.post(`${BASE}/${tiKaneId}`, { ...data, functionCode: 'TRANS_CREATE' }).then((r) => r.data),

  update: (tiKaneId, txId, data) =>
    api.put(`${BASE}/${tiKaneId}/${txId}`, { ...data, functionCode: 'TRANS_UPDATE' }).then((r) => r.data),

  remove: (tiKaneId, txId) =>
    api.delete(`${BASE}/${tiKaneId}/${txId}`, { data: { functionCode: 'TRANS_DELETE' } }).then((r) => r.data),

  payout: (tiKaneId) =>
    api.post(`${BASE}/${tiKaneId}/payout`, { functionCode: 'TRANS_CREATE' }).then((r) => r.data),
};
service.listByTiKane = service.list;
export default service;
